import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 10px;
  padding-right: 20px;

  .error-input {
    border-color: rgba(202, 34, 22, 0.7) !important;
    .ant-select-selector {
      border-color: rgba(202, 34, 22, 0.7) !important;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormItemContainer = styled.div`
  display: flex;
  padding-bottom: 20px;
  gap: 8px;
  align-items: start;
  width: 100%;
`;

export const FormItemLabel = styled.div<{required?: boolean}>`
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  font-weight: 600;

  &::after {
    color: #ff4d4f;
    margin-left: 4px;
    content: ${props => props.required ? "'*'" : "''"};
  }
`;

export const CategoryLabel = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ErrorMessage = styled.div`
  line-height: 1;
  color: rgba(202, 34, 22);
  font-size: 14px;
`;